import { Showcase } from "./Showcase";
import bedroom from "@/assets/bedroom.png";
import bedroomMain from "@/assets/bedroom_main.jpg";
import bedroomTv from "@/assets/bedroom_tv.jpg";
import shower from "@/assets/shower.png";
import suitePainting from "@/assets/suite_painting.jpg";
import suiteEnsuite from "@/assets/suite_ensuite.jpg";
import suiteRobe from "@/assets/suite_robe.jpg";
import suiteVanity from "@/assets/suite_vanity.jpg";
import gym from "@/assets/space_gym.png";
import gymWide from "@/assets/gym_wide.jpg";
import sauna from "@/assets/space_sauna.png";
import loungeA from "@/assets/space_lounge_a.png";
import loungeB from "@/assets/space_lounge_b.png";
import loungeCinemaWide from "@/assets/lounge_cinema_wide.jpg";
import loungeSnackbar from "@/assets/lounge_snackbar.jpg";
import loungePopcorn from "@/assets/lounge_popcorn.jpg";

export const Spaces = () => (
  <>
    <Showcase
      id="suite"
      no="01"
      overline="Rest"
      title="A cosy cellar retreat"
      body="Sink into luxurious bedding after a day exploring Wiltshire. The bedroom — cosy and characterful, with a comfortable king-size bed — flows into a sleek modern en-suite shower room and a kitchenette stocked with a premium coffee machine and refreshments. Everything considered, nothing forgotten."
      bullets={[
        "Bedroom with a king-size bed",
        "Modern en-suite shower room",
        "Kitchenette & premium coffee",
        "Luxury towels & toiletries",
      ]}
      images={[
        { src: bedroomMain, label: "Bedroom with a king-size bed" },
        { src: shower, label: "En-suite shower room" },
      ]}
      gallery={[
        { src: bedroomTv, label: "Smart TV & seating" },
        { src: bedroom, label: "The bedroom" },
        { src: suitePainting, label: "Vaulted cellar ceiling" },
        { src: suiteEnsuite, label: "Bedroom to en-suite" },
        { src: suiteRobe, label: "Robes & fresh linen" },
        { src: suiteVanity, label: "En-suite vanity" },
      ]}
      reverse={false}
      testId="space-suite"
    />

    <Showcase
      id="gym"
      no="02"
      overline="Move"
      title="Your own private gym"
      body="No need to skip a session. Work out in a well-equipped private gym — treadmill, spin bike, free weights and a step — set against a mirrored studio wall with a TV to train along to. Exclusively yours throughout your stay."
      bullets={[
        "Treadmill & spin bike",
        "Free weights & step",
        "Mirrored studio wall",
        "TV to train along to",
      ]}
      images={[
        { src: gym, label: "The private gym" },
        { src: gymWide, label: "Treadmill, spin bike & sauna" },
      ]}
      reverse={true}
      tinted
      testId="space-gym"
    />

    <Showcase
      id="sauna"
      no="03"
      overline="Unwind"
      title="Melt the day away in the sauna"
      body="Ease tired muscles in your private infrared sauna — the perfect way to slow down after a walk on the Ridgeway or a day among the stone circles. Fresh towels are always laid out, ready and waiting for you."
      bullets={["Private infrared sauna", "Fresh towels provided"]}
      images={[{ src: sauna, label: "The private sauna" }]}
      reverse={false}
      testId="space-sauna"
    />

    <Showcase
      id="lounge"
      no="04"
      overline="Relax"
      title="The cinema lounge"
      body="Sink into the enormous mustard sofa beneath a wall of signed film posters, fire up the huge TV with Sky and streaming, and help yourself to the popcorn machine. As we only ever host up to two guests at a time, the living room is exclusively yours — reserved for our guests alone, never communal or shared with anyone else. It's the perfect place to unwind, and one of those unexpected touches guests absolutely love."
      bullets={[
        "Huge TV — Sky & streaming",
        "Help-yourself popcorn machine",
        "Signed film posters",
        "Exclusively for our guests",
      ]}
      images={[
        { src: loungeCinemaWide, label: "The cinema lounge" },
        { src: loungeB, label: "Movie nights" },
      ]}
      gallery={[
        { src: loungeA, label: "The exclusive guest living room" },
        { src: loungePopcorn, label: "Popcorn machine" },
        { src: loungeSnackbar, label: "Help-yourself snack bar" },
      ]}
      reverse={true}
      tinted
      testId="space-lounge"
    />
  </>
);
